export const comparatorMap: { [key: string]: string } = {
  '<': 'Lesser than',
  '<=': 'Lesser than or equal to',
  '>': 'Greater than',
  '>=': 'Greater than or equal to'
}

export const rowSpanMap: { [key: number]: string } = {
  1: "row-span-1",
  2: "row-span-2",
  3: "row-span-3",
  4: "row-span-4",
  5: "row-span-5"
}

export const thresholdCategories = {
  "windSpeed" : {        
    "keyLabelMap" : {
      "surfaceWind" : "Surface Winds",
      "wind80M" : "Winds 80M", 
      "surfaceWindGust" : "Wind Gust",
    }, 
    "unitOptions" : {
      "Knots (kts)" : "KTS",
      "Miles per Hour (mph)" : "MPH",
      "Meters per Second (m/s)" : "MPS"
    },
    "label" : "Wind Speed"
  }, 
  "temperature" : { 
    "keyLabelMap" : {
      "temperatureHighRange" : "Temperature High Range",
      "temperatureLowRange" : "Temperature Low Range", 
    }, 
    "unitOptions" : {
      "Celcius (°C)" : "C",
      "Fahrenheit (°F)" : "F"
    },
    "label" : "Temperature"
  },
  "ceiling" : {
      "keyLabelMap" : {
        "ceilingHeight" : "Ceiling",
      }, 
      "unitOptions" : {
        "Feet (FT)" : "FT",
        "Meters (M)" : "M"
      },
      "label" : "Ceiling"
  },
  "visibility" : {
      "keyLabelMap" : {
        "visibility" : "Visibility",
      }, 
      "unitOptions" : {
        "Statute Miles (SM)" : "SM",
        "Miles (Mi)" : "Miles",
        "Kilometers (KM)": "KM"
      },
      "label" : "Visibility"
  },
  
  "precipitationRate" :{
    "keyLabelMap" : {
      "totalPrecipitation" : "Precipitation Rate",
    }, 
    "unitOptions" : {
      "Millimeter per Hour (mm/hr)" : "MM/HR",
      "Inches per Hour (in/hr)" : "IN/HR"
    },
    "label" : "Precipitation"
  },
  "precipitation" :{
    "keyLabelMap" : {
      "precipitation" : " Probability of Precipitation",
    }, 
    "unitOptions" : {
    },
    "label" : "Precipitation"
  },
  
  
  // "humidity" : {
  //   "keyLabelMap" : {
  //     "relativeHumidity" : "Relative Humidity"
  //   },
  //   "unitOptions" : {
  //     "Percent (%)" : "%"
  //   },
  //   "label" : "Humidity"
  // },
 
  "pressure" : {
    "keyLabelMap" : {},
    "unitOptions" : {
      "Hectopascal (hPa)" : "hPa",
      "Millibars (mb)" : "mb",
      "Inches of mercury (inHg)" : "inHg"
    },
    "label" : "Pressure"
  }
};